<template>
  <Modal
    id="transfer-confirmation"
    prevent-close
  >
    <div class="text-[#333333] flex flex-col gap-[20px] sm:px-[12px] py-[8px] sm:py-[20px]">
      <div class="flex flex-col gap-[4px]">
        <b class="block text-center text-[18px] sm:text-[24px] font-semibold">Konfirmasi Pembayaran</b>
        <span class="block text-center text-[12px] sm:text-[16px]">Konfirmasi pembayaran melalui Xendit</span>
      </div>
      <div class="mt-[8px] flex flex-col gap-[12px] sm:gap-[16px] text-[12px] sm:text-[14px]">
        <p class="font-medium mb-0 pb-[4px] sm:pb-[8px] border-b border-[#E2E2E2] border-dashed">
          Detail Transaksi
        </p>
        <div class="flex items-center justify-between gap-[16px]">
          <span class="text-[#828282] font-medium">Tanggal Transaksi</span>
          <span class="whitespace-nowrap"><span class="font-medium">{{ transactionDate.date }}</span> <span class="text-[#626262] hidden sm:!inline sm:!visible">| {{ transactionDate.time }} WIB</span></span>
        </div>
        <div class="flex items-center justify-between gap-[16px]">
          <span class="text-[#828282] font-medium">Nominal</span>
          <span class="font-medium whitespace-nowrap">{{ nominal }}</span>
        </div>
        <div class="flex items-center justify-between gap-[16px] pt-[4px] sm:pt-[8px] border-t border-[#E2E2E2] border-dashed">
          <span class="font-medium">Total<span class="hidden sm:inline sm:visible"> dibayarkan</span></span>
          <strong class="font-semibold text-[14px] sm:text-[20px]">{{ nominal }}</strong>
        </div>
      </div>
      <div class="flex flex-col gap-[12px]">
        <b-button
          variant="light"
          class="!rounded-[8px] truncate"
          :disabled="isLoading.cancel || isLoading.payment"
          @click="handleCancel"
        >
          <b-spinner
            v-if="isLoading.cancel"
            class="mr-[6px]"
            small
          />
          Batalkan Pembayaran
        </b-button>
        <b-button
          variant="primary"
          class="!rounded-[8px] truncate"
          :disabled="isLoading.cancel || isLoading.payment"
          @click="checkPayment"
        >
          <b-spinner
            v-if="isLoading.payment"
            class="mr-[6px]"
            small
          />
          Sudah Bayar
        </b-button>
      </div>
      <div
        v-if="!isPaid"
        class="py-[12px] sm:py-[16px] px-[16px] sm:px-[24px] rounded-[8px] bg-[#FFEDED]"
      >
        <b class="flex items-center font-medium text-[10px] sm:text-[12px] gap-[6px] sm:gap-[10px] text-[#E31A1A]">
          <i class="k-info-circle text-[16px]" />
          Pembayaran belum berhasil
        </b>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal.vue'

export default {
  components: { Modal },
  props: {
    transactionDate: {
      type: Object,
      default: () => ({ date: '22 Agustus 2025', time: '08:52' }),
    },
    nominal: {
      type: String,
      default: 'Rp10.000.000',
    },
    dataBillExist: {
      type: Object || null,
      default: null,
    },
  },
  data() {
    return {
      isPaid: true,
      isLoading: {
        cancel: false,
        payment: false,
      },
    }
  },
  methods: {
    async checkPayment() {
      this.isLoading.payment = true
      try {
        const { data: { data } } = await this.$store.dispatch('saldo/checkActiveBill')
        if (data.have_active_bill) {
          this.isPaid = false
          return
        }
        this.isPaid = true
        this.$bvModal.hide('transfer-confirmation')
        this.$emit('onSuccess')
      } catch (e) {
        this.$bvModal.hide('transfer-confirmation')
        this.$swal({
          title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
          text: e.message,
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      } finally {
        this.isLoading.payment = false
      }
    },
    async handleCancel() {
      this.isLoading.cancel = true
      try {
        const { data } = await this.$store.dispatch('saldo/cancelActiveBill', this.dataBillExist.invoice_xendit_id)
        if (data.code === 200) {
          this.$emit('onCancel')
          return
        }
        if (!data.status) throw data
      } catch ({ response }) {
        if (response.status && (response.status === 400 || (response.status === 404 && response.data.data.detail === 'could not find invoice by id'))) {
          this.$emit('onSuccess')
          return
        }
        this.$swal({
          title: '<span class="font-semibold h4">Pembatalan Pembayaran Gagal</span>',
          text: response.data.data,
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      } finally {
        this.isLoading.cancel = false
        this.$bvModal.hide('transfer-confirmation')
      }
    },
  },
}
</script>
